const Unauthorized = () => {
  return (
    <div
      data-testid="unauthorized-page"
      className="min-h-dvh flex items-center justify-center bg-neutral-100 px-4 text-ib-red-dark"
    >
      <div className="w-full max-w-md rounded-xl bg-white p-8 shadow-sm ring-1 ring-black/5 text-center">
        <div className="text-6xl font-ib-bold">401</div>
        <h1 className="mt-4 text-xl font-semibold ">No autorizado</h1>
      </div>
    </div>
  );
};

export default Unauthorized;
